import {AmendmentCpiBeneficiaryChange, AmendmentCpiPersonalData, AmendmentCpiTermination} from '../../models/amendment.model';
import {ValidationError} from '../../models/validation-error.model';

export namespace SalesCpiAsideAction {

    export class StartCancellationAmendment {
        static readonly type = 'SalesCpiAction.StartCancellationAmendment';
    }

    export class Cancellation {
        static readonly type = 'SalesCpiAction.Cancellation';

        constructor(public policyId: number) {
        }
    }

    export class StartTerminationAmendment {
        static readonly type = 'SalesCpiAction.StartTerminationAmendment';

        constructor(public policyId: number) {
        }
    }

    export class Termination {
        static readonly type = 'SalesCpiAction.Termination';

        constructor(public policyId: number, public data: AmendmentCpiTermination) {
        }
    }

    export class StartBeneficiaryChangeAmendment {
        static readonly type = 'SalesCpiAction.StartBeneficiaryChangeAmendment';
    }

    export class BeneficiaryChange {
        static readonly type = 'SalesCpiAction.BeneficiaryChange';

        constructor(public policyId: number, public data: AmendmentCpiBeneficiaryChange) {
        }
    }

    export class StartPersonalDataChangeAmendment {
        static readonly type = 'SalesCpiAction.StartPersonalDataChangeAmendment';
    }

    export class PersonalDataChange {
        static readonly type = 'SalesCpiAction.PersonalDataChange';

        constructor(public policyId: number, public data: AmendmentCpiPersonalData) {
        }
    }

    export class FormFailure {
        static readonly type = 'SalesCpiAsideAction.FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {
        }
    }

}
